import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X, BookOpen, Library, User } from 'lucide-react';
import { publisherData } from '../data/mockData';

export const Header = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');

  // Check session on mount
  useEffect(() => {
    const token = localStorage.getItem('reader_token');
    const user = localStorage.getItem('reader_user');
    if (token && user) {
      setIsLoggedIn(true);
      try {
        const userData = JSON.parse(user);
        setUserName(userData.name?.split(' ')[0] || 'Usuario');
      } catch (e) {
        // Invalid user data
      }
    }
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const goToReader = () => {
    if (isLoggedIn) {
      navigate('/reader/biblioteca');
    } else {
      navigate('/reader/register');
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md z-50 border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <button onClick={() => scrollToSection('home')} className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-br from-amber-600 to-amber-800 rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-xl">R</span>
            </div>
            <span className="text-2xl font-serif font-bold text-gray-900">{publisherData.name}</span>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <button 
              onClick={() => scrollToSection('home')}
              className="nav-link text-gray-700 hover:text-amber-700 transition-colors duration-300"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('libro')}
              className="nav-link text-gray-700 hover:text-amber-700 transition-colors duration-300"
            >
              Libros
            </button>
            
            {isLoggedIn ? (
              <button 
                onClick={goToReader}
                className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white rounded-full font-semibold transition-all duration-300 transform hover:scale-105 shadow-md"
              >
                <Library size={18} />
                <span>Mi Biblioteca</span>
              </button>
            ) : (
              <button 
                onClick={goToReader}
                className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-full font-semibold transition-all duration-300 transform hover:scale-105 shadow-md"
              >
                <BookOpen size={18} />
                <span>Leer Preview Gratis</span>
              </button>
            )}
            
            <button 
              onClick={() => scrollToSection('sobre-nosotros')}
              className="nav-link text-gray-700 hover:text-amber-700 transition-colors duration-300"
            >
              Sobre Nosotros
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="nav-link text-gray-700 hover:text-amber-700 transition-colors duration-300"
            >
              Contacto
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-3 border-t border-gray-200 pt-4">
            {isLoggedIn && (
              <div className="flex items-center gap-2 py-2 text-amber-600 font-medium">
                <User size={18} />
                <span>Hola, {userName}</span>
              </div>
            )}
            <button 
              onClick={() => scrollToSection('home')}
              className="block w-full text-left py-2 text-gray-700 hover:text-amber-700 transition-colors"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('libro')}
              className="block w-full text-left py-2 text-gray-700 hover:text-amber-700 transition-colors"
            >
              Libros
            </button>
            
            {isLoggedIn ? (
              <button 
                onClick={goToReader}
                className="block w-full text-left py-3 px-4 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-lg font-semibold"
              >
                📚 Ir a Mi Biblioteca
              </button>
            ) : (
              <button 
                onClick={goToReader}
                className="block w-full text-left py-3 px-4 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg font-semibold"
              >
                📖 Leer Preview Gratis
              </button>
            )}
            
            <button 
              onClick={() => scrollToSection('sobre-nosotros')}
              className="block w-full text-left py-2 text-gray-700 hover:text-amber-700 transition-colors"
            >
              Sobre Nosotros
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="block w-full text-left py-2 text-gray-700 hover:text-amber-700 transition-colors"
            >
              Contacto
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};